import {Tag} from "antd";

const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '支付类型',
      dataIndex: 'transactionType',
      width: 100,
    },
    {
      title: '收款类型',
      dataIndex: 'billTypeName',
      width: 100,
    },
    {
      title: '报价类型',
      dataIndex: 'quotedPriceTypeName',
      width: 100,
    },
    {
      title: '应收/应退（元）',
      dataIndex: 'canAmount',
      width: 136,
    },
    {
      title: '实收/实退（元）',
      dataIndex: 'amount',
      width: 136,
    },

    {
      title: '申请日期',
      dataIndex: 'applyTime',
      itemType: 'dateTime',
      width: 160,
    },
    {
      title: '财务处理日期',
      dataIndex: 'financialProcessingTime',
      itemType: 'dateTime',
      width: 160,
    },
    {
      title: '状态',
      dataIndex: 'billStateName',
      width: 100,
      render:(val,record)=>(
          <>
            {
              val?<Tag color={record?.billState==='verifyStateFinishedVerify'?'green':'blue'}>{val||""}</Tag>:null
            }
          </>
      )
    },
  ],
  search: [
    {
      name: 'transactionType',
      label: '支付类型',
      itemType: "select",
      data: [
        { label: "收款", key: '收款' },
        { label: "退款", key: '退款' },
      ],
    },
  ]
}

export default config
